import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
  closeIcon: { marginRight: 4, paddingBottom: 2 },
  switcher: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(2),
  },
}));
